import axios from 'axios';
import logger from '../utils/logger';

// Use environment variable for API URL, fallback to production if not set
const API_URL = import.meta.env.REACT_APP_API_URL || 'https://api.spark.rapidlearningcycles.com';

// Create axios instance with auth header
const getAuthHeader = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  return user?.access_token ? { Authorization: `Bearer ${user.access_token}` } : {};
};

// AI Coach service
const aiCoachService = {
  // Ask a question to the AI Coach
  askQuestion: async (question, conversationId = null, modelId = null) => {
    try {
      const response = await axios.post(
        `${API_URL}/ai-coach/ask`,
        { question, conversation_id: conversationId, model_id: modelId },
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      logger.error('Error asking AI Coach:', error);
      throw error;
    }
  },

  // Clear conversation memory (NEW FUNCTION)
  clearConversation: async (conversationId) => {
    try {
      const response = await axios.post(
        `${API_URL}/ai-coach/clear`,
        { conversation_id: conversationId },
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      logger.error('Error clearing conversation:', error);
      throw error;
    }
  },

  // Send message (alias for askQuestion for AICoachV2 compatibility)
  sendMessage: async ({ message, conversation_id, model_id }) => {
    try {
      const response = await axios.post(
        `${API_URL}/ai-coach/ask`,
        { question: message, conversation_id, model_id },
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      logger.error('Error sending message:', error);
      throw error;
    }
  }
};

export default aiCoachService;